import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BiArrowBack } from 'react-icons/bi';

const BarrelBlanketMyEntries = () => {
    const navigate = useNavigate();
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [username, setUsername] = useState('');

    useEffect(() => {
        const storedUsername = localStorage.getItem("apUsername");
        if (storedUsername) {
            setUsername(storedUsername);
        }
    }, []);

    useEffect(() => {
        if (username) {
            fetchMyEntries();
        }
    }, [username]);

    const fetchMyEntries = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("apUserToken");

            if (!token) {
                alert('Authentication token not found. Please login again.');
                setLoading(false);
                return;
            }

            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}barrelBlanket/user/${username}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            if (response.data.success) {
                setEntries(response.data.data || []);
            } else {
                alert(response.data.message || 'Failed to fetch entries');
            }
        } catch (error) {
            console.error('API Error:', error);
            alert('Failed to fetch entries. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Header */}
            <div className="bg-teal-600 text-white p-4 shadow-md">
                <div className="flex items-center gap-4">
                    <button onClick={() => navigate('/barrel-blanket')} className="text-white hover:text-gray-200">
                        <BiArrowBack size={24} />
                    </button>
                    <h1 className="text-2xl font-bold">My Barrel Blanket Entries</h1>
                </div>
            </div>

            {/* Content */}
            <div className="container mx-auto p-4 max-w-4xl">
                {loading ? (
                    <div className="flex items-center justify-center h-64">
                        <div className="text-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600 mx-auto mb-4"></div>
                            <p className="text-gray-600">Loading entries...</p>
                        </div>
                    </div>
                ) : entries.length > 0 ? (
                    <div className="space-y-4">
                        {entries.map((item, index) => (
                            <div
                                key={item._id || index}
                                onClick={() => navigate(`/barrel-blanket/details/${item._id}`)}
                                className="bg-gray-100 p-5 rounded-lg border border-gray-300 cursor-pointer hover:bg-gray-200 transition-colors"
                            >
                                <h3 className="text-lg font-bold text-teal-600 mb-2">
                                    {item.companyName || 'N/A'}, {item.city || 'N/A'}, {item.state || 'N/A'}
                                </h3>
                                <p className="text-sm text-teal-600">User: {item.username || 'N/A'}</p>
                                <p className="text-sm text-teal-600">Primary Customer Contact: {item.utility || 'N/A'}</p>
                                <p className="text-xs text-teal-600 mt-2">
                                    Date Time of Record: {new Date(item.createdAt).toLocaleString()}
                                </p>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center h-64">
                        <svg className="w-16 h-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                        </svg>
                        <p className="text-lg font-bold text-gray-600">No entries found</p>
                        <p className="text-sm text-gray-500 mt-2">You haven't submitted any barrel blanket investigation forms yet.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BarrelBlanketMyEntries;

